// extracted by mini-css-extract-plugin
export default {"icon":"NewClientType_icon__WB6Lk"};